import Banner from '../components/banner/banner'

class HomePage {
  constructor() {
    this.render()
  }

  render() {
    new Banner()
  }
}

export default HomePage
